'use strict';

angular.module('app.reCrawlPosts')
    .controller('reCrawlPostsCtrl', ['$scope', '$modal', 'reCrawlPostsService', 'adminService',
        function ($scope, $modal, reCrawlPostsService, adminService) {

        $scope.offset = 0;
        $scope.pageSize = 25;

        $scope.reCrawlPosts = function(limit, offset) {
            reCrawlPostsService.reCrawlPosts(limit, offset, true)
                .then(function(response) {
                    $scope.posts = response.data;
                    $scope.number = response.totalRow;
                }, function(response) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
                })
        }

        $scope.reCrawlPosts($scope.pageSize, $scope.offset);

        $scope.updatePage = function(currentPage) {
            $scope.offset = $scope.pageSize * (currentPage - 1);
            $scope.reCrawlPosts($scope.pageSize, $scope.offset);
        }

        $scope.pagination = function() {
            $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
        };
}])